import { createContext, useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export const DoorSectionContext = /*#__PURE__*/ createContext({ tab: "<invalid context>" });
export function DoorSectionProvider(props) { const ctx = useMemo(() => ({ tab: props.value }), [props.value]); return /*#__PURE__*/ _jsx(DoorSectionContext.Provider, { value: ctx, children: props.children }); }
